import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const predictionStatusManager = {
  getPredictionStatusData(url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'GET'
    });
  }
};

export default predictionStatusManager;
